<cw-full-screen-loader></cw-full-screen-loader>

<div class="twc-main-container">
    <cw-topbar></cw-topbar>
    <div class="twc-content-container" *ngIf="showContent">
        <div class="twc-content" [hidden]="appSharedService.loading && !appSharedService.keepBackgroundVisible">
            <div class="twc-content-area twc-p-0 twc-d-flex flex-direction-column">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <div class="width-100 height-100 twc-d-flex align-center justify-content-center" *ngIf="errorCode">
        <div class="twc-message-box twc-message-box-error">
            {{'MAGNET.ANONYMOUS_ACCESS_REVOKED' | translate}}
        </div>
    </div>
</div>